module.exports = __webpack_public_path__ + "static/img/3areaA_5.13daace.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/3areaA_5.png
// module id = 1027
// module chunks = 1